import { Flex, Skeleton, SkeletonBox } from '@utilitywarehouse/hearth-react';

import './styles.scss';

const TariffsSkeleton = () => {
  return (
    <Skeleton loadingTitle="Energy tariffs loading">
      <Flex className="energyTariff__skeletonWrapper">
        <SkeletonBox borderRadius="lg" height="340px" width="100%" />
        <SkeletonBox borderRadius="lg" height="340px" width="100%" />
        <SkeletonBox borderRadius="lg" height="340px" width="100%" />
      </Flex>
    </Skeleton>
  );
};

export { TariffsSkeleton };
